// extracted by mini-css-extract-plugin
export var table = "_wb-0";